import classNames from 'classnames';
import { FormattedMessage } from 'components/shared/Intl';
import { SpTooltip } from 'components/shared/Tooltip/Tooltip';
import { FC } from 'react';

export interface BlotterPanelActionButtonProps {
  id: string;
  containerClassName?: string;
  className: string;
  onClick: () => void;
  isDisabled?: boolean;
  label?: any;
  icon?: string;
  tooltip?: string;
  title?: string;
  iconStart?: boolean;
}

export const BlotterPanelActionButton: FC<BlotterPanelActionButtonProps> = ({
  id,
  containerClassName,
  className,
  onClick,
  isDisabled,
  label,
  icon,
  tooltip,
  title,
  iconStart,
}) => {
  const actionButton = (
    <button
      data-e2e={id}
      className={classNames('w-100 h-100', className)}
      type="button"
      onClick={onClick}
      disabled={isDisabled}
      title={title}
    >
      {iconStart ? (
        <>
          <i className="icon ms-1">{icon}</i>
          {label && <FormattedMessage id={label} />}
        </>
      ) : (
        <>
          {label && <FormattedMessage id={label} />}
          <i className="icon ms-1">{icon}</i>
        </>
      )}
    </button>
  );

  return (
    <SpTooltip position="top" contents={tooltip} color="info" disabled={!tooltip}>
      <div className={classNames('flex-grow-1 d-inline-flex', containerClassName)}>{actionButton}</div>
    </SpTooltip>
  );
};
